import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Home } from './pages/Home';
import { ConstructionPage } from './pages/ConstructionPage';
import { RenovationsPage } from './pages/RenovationsPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [pathname]);
  // Also scroll to top on initial page load/refresh
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}
function App() {
  return <LanguageProvider data-id="element-0">
      <Router data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <div className="min-h-screen bg-white" data-id="element-3">
          <Navbar data-id="element-4" />
          <WhatsAppButton data-id="element-5" />
          <Routes data-id="element-6">
            <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
            <Route path="/construccion" element={<ConstructionPage data-id="element-10" />} data-id="element-9" />
            <Route path="/reformas" element={<RenovationsPage data-id="element-12" />} data-id="element-11" />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>;
}
export { App };